var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXdIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539",
    transform: "translate(-274 -903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    transform: "translate(274 903)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-adobexd",
    "data-name": "Icon simple-adobexd",
    d: "M16.458.45H3.542A3.539,3.539,0,0,0,0,3.992V16.408A3.539,3.539,0,0,0,3.542,19.95H16.458A3.539,3.539,0,0,0,20,16.408V3.992A3.539,3.539,0,0,0,16.458.45Zm2.7,15.633a3.019,3.019,0,0,1-3.017,3.033H3.858A3.03,3.03,0,0,1,.833,16.092V4.308A3.03,3.03,0,0,1,3.858,1.283H16.133a3.025,3.025,0,0,1,3.025,3.025ZM7.908,9.575l2.333,4.483c.042.067.017.133-.05.133H8.742a.164.164,0,0,1-.175-.108c-.533-1.1-1.075-2.2-1.633-3.383H6.917c-.5,1.117-1.05,2.292-1.583,3.392a.16.16,0,0,1-.15.092H3.808c-.083,0-.092-.067-.05-.117l2.283-4.35-2.208-4.4a.067.067,0,0,1,.05-.117H5.317a.131.131,0,0,1,.15.092c.525,1.1,1.058,2.233,1.558,3.342h.017c.483-1.1,1.017-2.242,1.533-3.333.042-.067.067-.108.15-.108h1.342c.067,0,.092.05.05.117Zm2.742,1.358a3.26,3.26,0,0,1,3.342-3.458,3.7,3.7,0,0,1,.433.017V5.283a.084.084,0,0,1,.083-.083h1.317c.067,0,.083.025.083.067v7.65a5.936,5.936,0,0,0,.042.817c0,.05-.017.067-.067.092a4.964,4.964,0,0,1-2.133.483C11.942,14.317,10.65,13.2,10.65,10.933ZM14.425,8.8a1.26,1.26,0,0,0-.483-.083c-1.05,0-1.783.808-1.783,2.15,0,1.533.75,2.15,1.692,2.15a1.572,1.572,0,0,0,.575-.092V8.8Z",
    transform: "translate(279 907.55)",
    fill: "#8f6f6f"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdIcon);
export default __webpack_public_path__ + "static/media/xdIcon.8154cadaef215aaa5be3889efdd21839.svg";
export { ForwardRef as ReactComponent };